<script lang="ts">
  import Icon from './Icon.svelte';
  import type { FieldTypeKey } from '../lib/data-tables-catalog';

  // Усі FieldTypeKey присутні у реєстрі icons.ts → name={type} валідний.
  let { type, size = 14, class: cls = '' }: { type: FieldTypeKey; size?: number; class?: string } = $props();
</script>

<Icon name={type} {size} class={cls} />
